import React, {useState} from 'react';
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import {apiDateTimeStringToDate} from "src/api/apiDateTimeHandler";
import {format} from "date-fns";
import {styled, Typography, Zoom} from "@mui/material";
import ListItemButton from "@mui/material/ListItemButton";

const ProjectInstanceListItem = ({projectInstance, isSelected, onClick}) => {
  const [errorOccured, setErrorOccured] = useState(false);

  const StyledListItem = styled(ListItem)(({ theme }) => ({
    '& .MuiListItemButton-root': {
      backgroundColor: theme.palette.neutral.main,
    },
    '& .MuiListItemText-root': {
      fontWeight: 'bold',
      textAlign: 'center',
    }
  }))

  const StyledSelectedListItem = styled(ListItem)(({ theme }) => ({
    '& .MuiListItemButton-root': {
      backgroundColor: theme.palette.secondary.main,
    },
    '& .MuiListItemText-root': {
      fontWeight: 'bold',
      textAlign: 'center',
    }
  }))

  const primaryText = `${format(apiDateTimeStringToDate(projectInstance.start), 'kk:mm')} - ${format(apiDateTimeStringToDate(projectInstance.end), 'kk:mm')}`;

  const onProjectInstanceClick = () => {
    setErrorOccured(false);
    if (onClick) {
      onClick(projectInstance);
    }
  }

  if (!isSelected) {
    return (
      <Zoom in>
        <StyledListItem>
          <ListItemButton onClick={onProjectInstanceClick}>
            <ListItemText primary={primaryText} />
          </ListItemButton>
        </StyledListItem>
      </Zoom>
    );
  }

  return (
    <>
      <Zoom in>
        <StyledSelectedListItem>
          <ListItemButton onClick={onProjectInstanceClick}>
            <ListItemText primary={primaryText} />
          </ListItemButton>
        </StyledSelectedListItem>
      </Zoom>
      { errorOccured && <Typography variant="body1" color="status.danger.main">Er is iets fout gegaan. Probeer het nogmaals.</Typography> }
    </>
  )
}

export default ProjectInstanceListItem;

ProjectInstanceListItem.propTypes = {};

ProjectInstanceListItem.defaultProps = {};
